import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import CardRepository from '@/shared/http/repositories/crm/card.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'

import RestrictionAlert from '@/components/UI/restrictionAlert/restrictionAlert.vue'
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import DetailContainer from '../detailContainer/detailContainer.vue'
import ModalCardDelete from '@/views/private/crm/details/modal/carddeletemodal.vue'
import ModalCardLost from '@/views/private/crm/details/modal/lost/cardlostmodal.vue'
import ModalCardFinish from '@/views/private/crm/details/modal/finish/cardfinishmodal.vue'
import MoveCardPopover from '../moveCardColumn/moveCardColumn.vue'
import MoveCardBoardPopover from '../moveCardBoard/moveCardBoard.vue'

import InfoPersonModal from '../../details/person/modal/InfoPersonModal.vue'
import CrmDetailsPerson from '../../details/person/person.vue'
import CrmDetailsTimeline from '../../details/timeline/timeline.vue'
import CrmDetailsContacts from '../../details/contacts/Contact.vue'
import CrmDetailsAddress from '../../details/addresses/address.vue'
import CrmDetailsProduct from '../../details/product/product.vue'
import CrmDetailsInfo from '../../details/info/info.vue'
import CrmDetailsLeadOwner from '../../details/leadowner/leadowner.vue'
import CrmDetailsObservation from '../../details/observation/observation.vue'
import CrmDetailsAjuizamento from '../../details/ajuizamento/ajuizamento.vue'
import ModalNewFollowUp from '@/views/private/crm/details/followup/followup.vue'
import ModalCardDescription from '@/views/private/crm/details/card-description/ModalCardDescription.vue'
import AssociateRepository from '@/shared/http/repositories/business/associate'
import CrmDetailsCampanha from '@/views/private/crm/details/campanha/CampanhaTable.vue'
import CrmDetailsSerasa from '@/views/private/crm/details/serasa/SerasaDetails.vue'
import InvalidDocumentAlert from '@/components/UI/invalid-document-alert/InvalidDocumentAlert.vue'
import SerasaRepository from '../../../../../shared/http/repositories/configurations/serasa'
import ModalAddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import productSituation from '@/enums/enumProductSituation.js'
import cardSituation from '@/enums/enumCardSituation.js'
import boardTypes from '@/enums/enumBoardTypes.js'
import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'
import ChatModal from '@/views/private/atendimento/components/details/components/ChatModal.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import Protocols from '@/views/private/atendimento/components/protocols/Protocols.vue'

const cardDataModel = {
  'document': null,
  'boardColumnId': null,
  'motivoPerdaId': null,
  'origemLeadId': null,
  'pessoaId': null,
  'posicao': 0,
  'situacao': 0,
  'countReativado': 0,
  'dataCriacao': null,
  'dataInicioSituacao': null,
  'dataReativacao': null,
  'responsavel': null
}

export default {
  name: 'ModalCard',
  mixins: [ActionsForm],
  props: {
    cardId: {
      type: Number,
      default: null
    },
    boardColumns: {
      type: Array,
      required: false
    },
    isVisita: {
      type: Boolean,
      default: false
    },
    visitaId: {
      type: Number,
      default: null
    },
    board: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      card: null,
      products: null,
      person: null,
      personType: null,
      data: cardDataModel,
      productSituation: productSituation,
      cardSituation: cardSituation,
      boardTypes: boardTypes,
      boardArchived: false,
      boardColumnsToReload: [],
      editPersonInfo: false,
      openFollowUpModal: false,
      openCardDescriptionModal: false,
      openMoveCardComponent: false,
      openMoveCardBoardComponent: false,
      isMobile: screen.width <= 480,
      isTablet: screen.width <= 1000,
      ultimaConsulta: null,
      renda: null,
      score: null,
      parametroScore: false,
      parametroRenda: false,
      functionModalAddConfirmation: null,
      textModalAddConfirmation: null,
      showConversation: false,
      messages: [],
      allConversations: [],
      hasAtendimento: process.env.hasAtendimento,
      totalPage: 0,
      pageSize: 6,
      personTelefone: null,
      alterarResponsavel: false
    }
  },
  components: {
    InvalidDocumentAlert,
    RestrictionAlert,
    DefaultButton,
    DetailContainer,
    CrmDetailsTimeline,
    CrmDetailsPerson,
    CrmDetailsObservation,
    CrmDetailsContacts,
    CrmDetailsAddress,
    CrmDetailsProduct,
    CrmDetailsInfo,
    CrmDetailsLeadOwner,
    CrmDetailsAjuizamento,
    InfoPersonModal,
    ModalNewFollowUp,
    ModalCardDescription,
    ModalCardDelete,
    ModalCardLost,
    ModalCardFinish,
    MoveCardPopover,
    MoveCardBoardPopover,
    CrmDetailsCampanha,
    CrmDetailsSerasa,
    ModalAddConfirmation,
    ChatModal,
    Protocols
  },
  created () {
    this.onLoadLead(this.cardId)
  },
  async mounted () {
    const resp = await SerasaRepository.GetParams()
    if (resp.data.score) this.parametroScore = true
    if (resp.data.renda) this.parametroRenda = true

    this.showModal()
  },
  computed: {
    cardActive () {
      return this.card && this.card.situacao === 'ATIVO' && !this.card.boardColumn.board.arquivado && !this.card.boardColumn.board.isReadOnly && !this.card.readOnly
    },
    cardActiveAndAjuizamentoBoardAction () {
      if (!this.card || !this.card.boardColumn || !this.card.boardColumn.board) {
        return false
      }
      return (
        (this.card.situacao === 'ATIVO' && !this.card.boardColumn.board.arquivado && !this.card.boardColumn.board.isReadOnly && !this.card.readOnly) ||
        (!this.card.readOnly && this.card.boardColumn.board.tipoBoard === 'AJUIZAMENTO' && new Date(this.card.boardColumn.board.dataFinal) >= new Date())
      )
    },
    ajuizamentoBoardAction () {
      if (!this.card || !this.card.boardColumn || !this.card.boardColumn.board) {
        return false
      }
      return (
        (!this.card.readOnly && this.card.boardColumn.board.tipoBoard === 'AJUIZAMENTO' && new Date(this.card.boardColumn.board.dataFinal) >= new Date())
      )
    }
  },
  methods: {
    // MODAL METHODS
    showModal () {
      this.$refs['modal-crmCard'].show()
    },
    hideModal () {
      // this.clearForms()
      this.$emit('hideModal', 'hideModal')
      this.$refs['modal-crmCard'].hide()
    },
    clearForms () {
      this.boardColumnsToReload = []
      this.selectedOption = null
      this.options = []
      this.cardToRemove = {
        cardId: null,
        boardColumnId: null
      }
      this.data = cardDataModel
      this.card = null
    },
    async onCopy (text) {
      try {
        await navigator.clipboard.writeText(text)
        toast.success('Texto copiado para área de transferência')
      } catch (err) {
        console.error('Failed to copy text to clipboard:', err)
      }
    },
    // LOADS
    onLoadLead () {
      if (this.cardId) {
        CardRepository.GetById(this.cardId)
          .then(async (response) => {
            if (response.status === 200) {
              this.card = response.data
              this.alterarResponsavel = this.card.boardColumn.board.alterarResponsavel
              // Voltar ao normal após Daniel resolver cards arquivados vindo no requqst
              // this.boardArchived = response.data.boardColumn.board.arquivado
              this.person = response.data.pessoa
              this.personType = this.person.document
                ? (this.person.document.length === 11 ? 'Pessoa Física' : (this.person.document.length === 14 ? 'Pessoa Jurídica' : null))
                : null
              this.ultimaConsulta = response.data.pessoa.serasa ? response.data.pessoa.serasa.dataConsulta : null
              this.renda = response.data.pessoa.serasa && response.data.pessoa.serasa.infoCadastraisCreditBureau
                ? response.data.pessoa.serasa.infoCadastraisCreditBureau.renda
                : null
              this.score = response.data.pessoa.serasa && response.data.pessoa.serasa.infoCadastraisCreditBureau
                ? response.data.pessoa.serasa.infoCadastraisCreditBureau.score
                : null

              this.onLoadCardSyncDb(this.card)

              return this.getConversations(response.data.pessoa)
            }
          })
          .catch((e) => {
            console.error(e.message)
          })

        this.$nextTick(() => {
          this.onReloadFollowup()
        })
      }
    },

    onLoadCardSyncDb (card, newIndex) {
      if (card) {
        this.data.id = card.id
        this.data.boardColumnId = (card.boardColumn ? card.boardColumn.id : null)
        this.data.motivoPerdaId = card.motivoPerda ? card.motivoPerda.id : null
        this.data.posicao = newIndex || card.posicao
        this.data.situacao = card.situacao
        this.data.countReativado = card.countReativado
        this.data.dataCriacao = card.dataCriacao
        this.data.dataInicioSituacao = card.dataInicioSituacao
        this.data.dataReativacao = card.dataReativacao
        this.data.origemLeadId = card.origemLead ? card.origemLead.id : null
        this.data.pessoaId = card.pessoa ? card.pessoa.id : null
        this.data.ultimaConsulta = card.pessoa.serasa ? card.pessoa.serasa.dataConsulta : null
        this.data.score = card.pessoa.serasa && card.pessoa.serasa.infoCadastraisCreditBureau ? card.pessoa.serasa.infoCadastraisCreditBureau.score : null
        this.data.renda = card.pessoa.serasa && card.pessoa.serasa.infoCadastraisCreditBureau ? card.pessoa.serasa.infoCadastraisCreditBureau.renda : null
      }
    },
    async onLoadAllProducts () {
      if (this.card) {
        try {
          const response = await CardProductRepository.Search(this.card.id, 100, 0)
          this.products = response.data.content
        } catch (error) {
          this.onException(error)
        }
      }
    },
    // CUSTOM UPDATES
    closeAndUpdate (idSecondaryBoard) {
      if (idSecondaryBoard) this.boardColumnsToReload.push(idSecondaryBoard)
      if (this.boardColumnsToReload) this.updateBoardColumns()
      this.$nextTick(() => {
        this.hideModal()
      })
    },
    updateBoardColumns () {
      if (!this.boardColumnsToReload.some(column => column === this.card.boardColumn.id)) this.boardColumnsToReload.push(this.card.boardColumn.id)
      this.$emit('reloadBoardColumns', this.boardColumnsToReload)
    },
    updateBoardAndPerson () {
      this.onLoadLead()
      if (this.boardColumnsToReload) this.updateBoardColumns()
      this.onReloadFollowup()
    },
    // MANAGE CRM DETAILS
    openNewFollowUp () {
      this.openFollowUpModal = true
      // this.$refs.ModalNewFollowUp.showModal()
    },
    closeNewFollowUp () {
      this.openFollowUpModal = false
      this.onReloadBoardAndFollowUp()
      // this.onReloadFollowup()
    },
    openNewCardDescription () {
      this.openCardDescriptionModal = true
    },
    closeNewCardDescription () {
      this.openCardDescriptionModal = false
      this.onReloadBoardAndFollowUp()
      // this.onReloadFollowup()
    },
    openEditPerson () {
      this.editPersonInfo = true
    },
    closeEditPerson () {
      this.onLoadLead()
      this.editPersonInfo = false
    },
    openAddObs () {
      this.$refs.CrmDetailsObservation.onAddObs()
    },
    openAddPhone () {
      this.$refs.CrmDetailsContacts.onAddPhone()
    },
    formatNumberToReal (value) {
      let brazilianReal = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
      return brazilianReal.format(value.substring(0, value.length - 2))
    },
    formatInteger (value) {
      return parseInt(value)
    },
    openAddAddress () {
      this.$refs.CrmDetailsAddress.onNewAddress()
    },
    openAddProduct () {
      this.$refs.CrmDetailsProduct.onAddProduct()
    },
    openAddAjuizamento () {
      this.$refs.CrmDetailsAjuizamento.addAjuizamento()
    },
    // MOVE CARD THRU COLUMNS
    openMoveCard () {
      this.openMoveCardComponent = true
      this.openMoveCardBoardComponent = false
      // if (!this.isTablet) this.$refs.moveCardPopover.openMoveCard()
    },
    openMoveCardBoard () {
      this.openMoveCardBoardComponent = true
      this.openMoveCardComponent = false
    },
    movedCard (idSecondaryBoard, card, dataInicioSituacao) {
      this.onLoadCardSyncDb(card)
      this.data.dataInicioSituacao = dataInicioSituacao
      this.closeAndUpdate(idSecondaryBoard)
    },
    movedCardBoard (idPrimaryBoardColumn) {
      this.closeAndUpdate(idPrimaryBoardColumn)
    },
    // END CARD
    async manageSituation (situation) {
      switch (situation) {
        case cardSituation.GANHO:
          if (await this.validatePendingProducts(cardSituation.GANHO)) this.onGain()
          break
        case cardSituation.PERDIDO:
          if (await this.validatePendingProducts(cardSituation.PERDIDO)) this.onLost()
          break
        case cardSituation.FINALIZADO:
          this.onFinish()
          break
        case 'DELETE':
          this.onCancel()
          break
        default:
          break
      }
    },
    onGain () {
      if (this.cardId) {
        const gainData = {
          id: this.cardId,
          situacao: 'GANHO',
          dataInicioSituacao: new Date().toISOString()
        }
        CardRepository.PatchSituacao(gainData)
          .then((response) => {
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.closeAndUpdate()
              // this.onLoadLead() // TODO: Nao precisa de reload. O back retorna o objeto alterado
              createNewFollowupWithCard(this.card.pessoa.document, 'sys_oportunidade_ganha', `Definiu o Card de ' + ${this.card.pessoa.nome} + ' como ganho!`, this.ip, this.latitude, this.longitude, this.card.id)
            }
          })
          .catch((e) => {
            if (e.data && e.data.errors.length > 0) {
              if (e.data.errors[0].message && e.data.errors[0].message.match(/produto/)) {
                toast.error(e.data.errors[0].message)
              }
            }
          })
      }
    },
    onLost () {
      this.$refs.ModalCardLost.showModal(this.card)
    },
    onFinish () {
      this.$refs.ModalCardFinish.showModal(this.card)
    },
    onCancel () {
      this.$refs.ModalCardDelete.showModal(this.card)
    },
    async validatePendingProducts (situation) {
      await this.onLoadAllProducts()

      let pendingProducts = this.retrieveActiveProducts()
      let boardVenda = this.card.boardColumn.board.tipoBoard === this.boardTypes.VENDA
      let boardCobranca = this.card.boardColumn.board.tipoBoard === this.boardTypes.COBRANCA

      if (!pendingProducts.length || (!boardVenda && !boardCobranca) || (!boardCobranca && !this.card.boardColumn.board.ganhoPorProduto)) return true

      switch (situation) {
        case productSituation.GANHO:
          this.functionModalAddConfirmation = () => this.onGain()
          this.formatTextModalAddConfirmation(pendingProducts,
            boardVenda ? productSituation.GANHO : productSituation.LIQUIDADO)

          this.$refs['ModalAddConfirmation'].showModal()
          return false
        case productSituation.PERDIDO:
          this.functionModalAddConfirmation = () => this.onLost()
          this.formatTextModalAddConfirmation(pendingProducts, productSituation.PERDIDO)
          this.$refs['ModalAddConfirmation'].showModal()
          return false
        default:
          return false
      }
    },
    formatTextModalAddConfirmation (products, situation) {
      let singular = products.length === 1
      if (singular) {
        this.textModalAddConfirmation = `O produto ativo ${products.join(', ')}, será definido como ${situation}, junto á oportunidade. Deseja prosseguir?`
      } else {
        this.textModalAddConfirmation = `Os produtos ativos ${products.join(', ')}, serão definidos como ${situation}, junto á oportunidade. Deseja prosseguir?`
      }
    },
    retrieveActiveProducts () {
      let products = this.products
      let activeProducts = []

      // Em algumas bases, há cards ativos sem flag na coluna
      products.forEach(product => {
        if (product.situacao === this.productSituation.ATIVO || product.situacao === null) activeProducts.push(product.produtoDTO.nome)
      })

      return activeProducts
    },
    onReloadBoardAndFollowUp () {
      this.onReloadFollowup()
      if (this.boardColumnsToReload) this.updateBoardColumns()
    },
    onReloadPersonAndFollowup () {
      this.onReloadFollowup()
      this.onLoadLead()
    },
    onReloadFollowup () {
      if (this.$refs.CrmDetailsTimeline) this.$refs.CrmDetailsTimeline.onLoadAllFollowup()
    },
    onReloadChangeLeadOwner () {
      // WTF LMAO
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    async openAssociatePage () {
      let associateId = await this.getAssociateId(this.person.document)

      const routeData = this.$router.resolve({
        name: 'DetalhesAssociate',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      window.open(routeData.href, '_blank')
      this.$router.resolve(0)
    },
    async getAssociateId (document) {
      if (document) {
        let id = null
        await AssociateRepository.GetByDocument(document)
          .then(response => {
            id = response.data.content[0].id
          })
        return id
      }
    },
    async getPages (person) {
      this.isLoading = true
      this.personTelefone = '55' + person.telefone.filter(t => t.tipoContato === 'CELULAR')[0].telefone.replace(/\D/g, '')

      const requestConfig = {
        status: 'Finalizado',
        identifier: this.personTelefone
      }

      try {
        const response = await AtendimentoRepository.GetPages(requestConfig)
        const { status, data } = response

        if (status === 200) {
          const pageTotal = Math.ceil(data.count / this.pageSize)
          return pageTotal
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async getConversations (person) {
      this.isLoading = true
      const page = await this.getPages(person)
      this.personTelefone = '55' + person.telefone.filter(t => t.tipoContato === 'CELULAR')[0].telefone.replace(/\D/g, '')

      const requestConfig = {
        status: 'Finalizado',
        identifier: this.personTelefone,
        page: page,
        pageSize: this.pageSize
      }

      try {
        const response = await AtendimentoRepository.GetConversations(requestConfig)
        const { status, data } = response

        if (status === 200) {
          this.allConversations = data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    cardByAjuizamento (card) {
      return card.boardColumn.board.geraCardPorAjuizamento
    },
    isAjuizamento (card) {
      return (card && card.boardColumn.board.tipoBoard === 'AJUIZAMENTO') || false
    },
    hasSerasaConsult (card) {
      return !!(card && card.pessoa.serasa)
    },
    checkCardHasWebsocketCampaign (card) {
      if (card.utmCampaign ||
        card.utmContent ||
        card.utmMedium ||
        card.utmSource ||
        card.utmTerm
      ) {
        return true
      } else {
        return false
      }
    },
    formatDay (isoString) {
      const date = new Date(isoString)
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    handleClick (conversationId, provider, identifierProvider) {
      this.$refs.messagesModal.openAttachModalMessages(conversationId, provider, identifierProvider)
    },
    getConditionIconClass (condition) {
      if (condition === null) {
        return 'fa fa-hand-paper text-warning'
      } else if (condition) {
        return 'fa fa-thumbs-up text-success'
      } else {
        return 'fa fa-thumbs-down text-danger'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/components/modalCard/modalCard.js